import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

import { getBackgroundImages } from '../redux';
import { getPdpCardShortName } from 'page_modules/business-pdp/redux';

import styles from '../__styles__/backImgNew.scss?modules';

const BackgroundImage = ({ backgroundImages, shortName }) => {
  const imgNameMobile = 'mobile';
  const imgNameTablet = 'tablet';
  const imgNameDesktop = 'desktop';
  const imgNameUltrawide = 'ultrawide';

  return (
    <picture className={clsx(styles.picture, styles[shortName])}>
      {backgroundImages[imgNameMobile] && (
        <source
          media="(max-width: 767px)"
          srcSet={backgroundImages[imgNameMobile].url}
        />
      )}
      {backgroundImages[imgNameTablet] && (
        <source
          media="(min-width: 768px) and (max-width: 1023px)"
          srcSet={backgroundImages[imgNameTablet].url}
        />
      )}
      {backgroundImages[imgNameDesktop] && (
        <source
          media="(min-width: 1024px) and (max-width: 1279px)"
          srcSet={backgroundImages[imgNameDesktop].url}
        />
      )}
      {backgroundImages[imgNameUltrawide] && (
        <source
          media="(min-width: 1280px)"
          srcSet={backgroundImages[imgNameUltrawide].url}
        />
      )}

      <img srcSet={backgroundImages[imgNameDesktop].url} alt="" />
    </picture>
  );
};

const mapStateToProps = state => ({
  backgroundImages: getBackgroundImages(state),
  shortName: getPdpCardShortName(state)
});

export default connect(mapStateToProps)(BackgroundImage);
